module.exports = __webpack_public_path__ + "img/rain-gauge.e734606a.png";